// extracted by mini-css-extract-plugin
module.exports = {"front":"_Xwm3tI7","back":"_1zStUDe","flipContainer":"_1BwHz7f","flipper":"_2X30DMi","flipped":"_3dmIhk_"};